<script>
import Papa from 'papaparse'
import VueJsonToCsv from 'vue-json-to-csv'

export default {
  name: 'HomeView',
  components: {
    
  },
  data(){
    return {
        directionText: 'Scan Order Number: ',
        tempText: '',
        productsCSV:[],
        ordersCSV:[],
        curOrder: []
    }
  },
  methods: {
    handleEnter(){
        console.log("hi")
        if(this.tempText.length == 6){
            this.curOrder = this.ordersCSV.filter((el) => el.Name === this.tempText)
            console.log(this.curOrder)
        }
    },
    handleFileUploadProd(event){
      const file = event.target.files[0]
      if (file) {
        Papa.parse(file, {
          header: true, // Treat the first row as headers
          skipEmptyLines: true, // Skip any empty lines in the file
          complete: (results) => {
            // The parsed data is available in results.data as an array of objects
            this.productsCSV = results.data;
            console.log("Parsing complete:", this.productsCSV);
          },
          error: (error) => {
            console.error("Error parsing CSV:", error);
          }
        })
      }
    },
    handleFileUploadOrd(event){
      const file = event.target.files[0]
      if (file) {
        Papa.parse(file, {
          header: true, // Treat the first row as headers
          skipEmptyLines: true, // Skip any empty lines in the file
          complete: (results) => {
            // The parsed data is available in results.data as an array of objects
            this.ordersCSV = results.data;
            console.log("Parsing complete:", this.ordersCSV);
          },
          error: (error) => {
            console.error("Error parsing CSV:", error);
          }
        })
      }
    }
  }
}
</script>

<template>
    <h1>Ecom</h1>
    Product
    <input v-if="!productsCSV.length" id="choose-file" type="file" @change="handleFileUploadProd" accept=".csv" placeholder="Enter Product CSV" /> <br>
    Orders
    <input v-if="!ordersCSV.length" id="choose-file" type="file" @change="handleFileUploadOrd" accept=".csv" placeholder="Enter Order CSV" /> <br>
    
    <h2>{{ this.directionText }}</h2>
    <input v-model="tempText" @keyup.enter="handleEnter" placeholder="Enter Order Number/Barcode" />
    {{ this.curOrder }}

</template>
